module.exports = __webpack_public_path__ + "8de1338f8c51573d13332cfb8f79d424.pdf";